export const environment = {
  production: false,
  timezone: 'GMT',
  validQualifiers: ['MPAA', 'TVPG'],
  langFilters: ['es','en'],
  defaultLang: 'es',
  apiUrl: 'https://waemjxpqs6.execute-api.us-west-2.amazonaws.com/api'
};
